"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeTypeSchema = exports.NodeConfigSchema = exports.artifactType = void 0;
const zod_1 = require("zod");
const finley_types_1 = require("@finley-technologies/finley-types");
const types_1 = require("../../uiNodes/tapes/org-provided-inputs/types");
exports.artifactType = 'orgProvidedInputs';
exports.NodeConfigSchema = types_1.IntermediateRecordConfigSchema;
exports.NodeTypeSchema = zod_1.z.object({
    ...finley_types_1.DbTable.ArtifactWithSlugsSchema.omit({
        configuration: true,
        type: true,
    }).shape,
    externalFilename: zod_1.z.null(),
    type: zod_1.z.literal(exports.artifactType),
    loanProductSlug: zod_1.z.null(),
    creditFacilitySlug: zod_1.z.null(),
    configuration: exports.NodeConfigSchema,
});
//# sourceMappingURL=node.js.map